(function () {
  Flint.file("views/pages/aboutPage.js", function (require) {
    Flint.staticStyles("AboutPage", {
      "$page": "#_flintapp page.AboutPage, #_flintapp .AboutPage.page, #_flintapp .ViewAboutPage.page, #_flintapp .AboutPage > .page",
      "$header": "#_flintapp header.AboutPage, #_flintapp .AboutPage.header, #_flintapp .ViewAboutPage.header, #_flintapp .AboutPage > .header",
      "$aboutSec": "#_flintapp aboutSec.AboutPage, #_flintapp .AboutPage.aboutSec, #_flintapp .ViewAboutPage.aboutSec, #_flintapp .AboutPage > .aboutSec",
      "$para": "#_flintapp para.AboutPage, #_flintapp .AboutPage.para, #_flintapp .ViewAboutPage.para, #_flintapp .AboutPage > .para",
      "$aboutLink": "#_flintapp aboutLink.AboutPage, #_flintapp .AboutPage.aboutLink, #_flintapp .ViewAboutPage.aboutLink, #_flintapp .AboutPage > .aboutLink",
      "$teamMemberSec": "#_flintapp teamMemberSec.AboutPage, #_flintapp .AboutPage.teamMemberSec, #_flintapp .ViewAboutPage.teamMemberSec, #_flintapp .AboutPage > .teamMemberSec",
      "$portrait": "#_flintapp portrait.AboutPage, #_flintapp .AboutPage.portrait, #_flintapp .ViewAboutPage.portrait, #_flintapp .AboutPage > .portrait",
      "$teamMemberName": "#_flintapp teamMemberName.AboutPage, #_flintapp .AboutPage.teamMemberName, #_flintapp .ViewAboutPage.teamMemberName, #_flintapp .AboutPage > .teamMemberName",
      "$teamMemberEmail": "#_flintapp teamMemberEmail.AboutPage, #_flintapp .AboutPage.teamMemberEmail, #_flintapp .ViewAboutPage.teamMemberEmail, #_flintapp .AboutPage > .teamMemberEmail",
      "$teamMemberTitle": "#_flintapp teamMemberTitle.AboutPage, #_flintapp .AboutPage.teamMemberTitle, #_flintapp .ViewAboutPage.teamMemberTitle, #_flintapp .AboutPage > .teamMemberTitle",
      "$teamMemberBio": "#_flintapp teamMemberBio.AboutPage, #_flintapp .AboutPage.teamMemberBio, #_flintapp .ViewAboutPage.teamMemberBio, #_flintapp .AboutPage > .teamMemberBio"
    }, {
      "$page": {
        padding: [20, 20, 32]
      },
      "$header": {
        fontSize: 36,
        marginBottom: 12
      },
      "$aboutSec": {
        marginBottom: 32
      },
      "$para": {
        marginBottom: 20,
        textAlign: 'justify',
        display: 'block',
        fontFamily: 'helvetica neue',

        fontSize: 12,
        lineHeight: '175%'
      },
      "$aboutLink": {
        fontWeight: 'bold',
        display: 'inline'
      },
      "$teamMemberSec": {
        flexDirection: 'row',
        marginBottom: 32
      },
      "$portrait": {
        flexShrink: 0,
        borderRadius: '50%',
        border: '1px solid #ddd',
        marginRight: 20
      },
      "$teamMemberName": {
        flexDirection: 'row',

        fontSize: 20
      },
      "$teamMemberEmail": {
        width: 16,
        position: 'relative',
        left: 6,
        opacity: 0.8
      },
      "$teamMemberTitle": {
        fontSize: 13
      },
      "$teamMemberBio": {
        display: 'block',
        textAlign: 'justify',
        fontSize: 12,
        lineHeight: '150%',
        fontFamily: 'helvetica neue'
      }
    });
    Flint.view("AboutPage", function (view, on, $) {
      var context = initContext(view, {
        colors: atom(),
        isMobile: atom()
      });

      on.mount(function () {
        M.mixpanel.track("PageView", { page: 'about' });
      });view.render(function () {
        return view.el(["NavBar", 1], null);
      });view.render(function () {
        return view.el(
          ["page", 1],
          null,
          view.el(
            ["aboutSec", 1],
            null,
            view.el(
              ["header", 1],
              null,
              "About"
            ),
            view.el(
              ["aboutInfo", 1],
              null,
              view.el(
                ["para", 1],
                null,
                "Positive Relating, Inc was founded in 2006 with a mission to explore what’s possible in our social lives: our family, friendships and romantic relationships. We are now one of the largest and most renowned dating companies in the world. We believe that meeting new romantic partners, having great conversations, and making real connections are skills that anyone can learn with our methodology."
              ),
              view.el(
                ["para", 2],
                null,
                "Our men’s program, ",
                view.el(
                  ["Link", 1],
                  { className: "aboutLink", to: "/3sa" },
                  "3 Second Attraction"
                ),
                ", has helped tens of thousands of men all over of the world in their love life - including executives, self-made millionaires, working professionals and college students. Our women’s TV show, ",
                view.el(
                  ["Link", 2],
                  { className: "aboutLink", to: "http://thegirlsgame.tv", target: "_blank" },
                  "The Girl’s Game"
                ),
                ", has 6 million viewers."
              ),
              view.el(
                ["para", 3],
                null,
                "We continue to teach workshops ",
                view.el(
                  ["Link", 3],
                  { className: "aboutLink", to: "/residential/men" },
                  "for men"
                ),
                " and ",
                view.el(
                  ["Link", 4],
                  { className: "aboutLink", to: "/residential/women" },
                  "for women"
                ),
                " on topics including:",
                view.el(
                  ["ul", 1],
                  null,
                  view.el(
                    ["li", 1],
                    null,
                    "Revealing your true charming personality"
                  ),
                  view.el(
                    ["li", 2],
                    null,
                    "How to open a conversation with a stranger you’re attracted to"
                  ),
                  view.el(
                    ["li", 3],
                    null,
                    "What to look for in a short-term and long-term relationship"
                  ),
                  "Owning your sexual desire",
                  view.el(
                    ["li", 4],
                    null,
                    "Problem solving in a relationship"
                  ),
                  view.el(
                    ["li", 5],
                    null,
                    "Becoming more self-assured and emotionally available"
                  ),
                  view.el(
                    ["li", 6],
                    null,
                    "The ",
                    view.el(
                      ["Link", 5],
                      { className: "aboutLink", to: "http://integralcenter.org/what-is-circling/", target: "_blank" },
                      "Integral Circling"
                    ),
                    " experience to “see and be seen”"
                  )
                ),
                "Our professional dating coaches are based in over 40 major metropolitan English-speaking cities throughout the world, including Los Angeles, San Francisco, New York, Melbourne, Perth and London."
              ),
              view.el(
                ["para", 4],
                null,
                "We created ",
                view.el(
                  ["Link", 6],
                  { className: "aboutLink", to: "https://mrright.net", target: "_blank" },
                  "Mr. Right"
                ),
                ", the dating app where men step up their game."
              ),
              view.el(
                ["para", 5],
                null,
                "And we write the world’s most thorough analysis of texting: ",
                view.el(
                  ["Link", 7],
                  { className: "aboutLink", to: "https://texting.tips", target: "_blank" },
                  "Texting Tips"
                ),
                "."
              )
            )
          ),
          view.el(
            ["teamSec", 1],
            null,
            view.el(
              ["header", 2],
              null,
              "Team"
            ),
            view.el(
              ["teamInfo", 1],
              null,
              view.el(
                ["teamMemberSec", 1],
                null,
                view.el(["img", 1], { className: "portrait", src: "/images/mehow-headshot.png" }),
                view.el(
                  ["teamMemberInfo", 1],
                  null,
                  view.el(
                    ["teamMemberName", 1],
                    null,
                    "Mehow",
                    view.el(
                      ["a", 1],
                      { className: "teamMemberEmailLink", href: "mailto:mehow@positiverelating.tv" },
                      view.el(["img", 2], { className: "teamMemberEmail", src: "/images/email.png" })
                    )
                  ),
                  view.el(
                    ["teamMemberTitle", 1],
                    null,
                    "Founder & CEO"
                  ),
                  view.el(
                    ["teamMemberBio", 1],
                    null,
                    "Mehow was born Michal Pospieszalski in Warsaw, Poland. Since 2006, he has devoted himself to mastering the art of creating fulfilling relationships. Mehow has written eight books about attraction, seduction, dating and relationships. He has given countless talks and personally taught thousands of students. He is the host and creator of Yahoo's ",
                    view.el(
                      ["i", 1],
                      null,
                      "The Girl's Game"
                    ),
                    "."
                  )
                )
              ),
              view.el(
                ["teamMemberSec", 2],
                null,
                view.el(["img", 3], { className: "portrait", src: "/images/angie-headshot-2.png" }),
                view.el(
                  ["teamMemberInfo", 2],
                  null,
                  view.el(
                    ["teamMemberName", 2],
                    null,
                    "Angie Chavez",
                    view.el(
                      ["a", 2],
                      { className: "teamMemberEmailLink", href: "mailto:angie@positiverelating.tv" },
                      view.el(["img", 4], { className: "teamMemberEmail", src: "/images/email.png" })
                    )
                  ),
                  view.el(
                    ["teamMemberTitle", 2],
                    null,
                    "Operations Manager"
                  ),
                  view.el(
                    ["teamMemberBio", 2],
                    null,
                    "Angie is the co-author of ",
                    view.el(
                      ["Link", 8],
                      { className: "aboutLink", to: "/3sa" },
                      "3 Second Attraction"
                    ),
                    " and ",
                    view.el(
                      ["Link", 9],
                      { className: "aboutLink", to: "/enchant-mr-right" },
                      "Enchant Mr. Right"
                    ),
                    ". She has written dozens of lesson materials for Positive Relating. She leads the interview and evaluation process for ",
                    view.el(
                      ["Link", 10],
                      { className: "aboutLink", to: "https://mrright.net", target: "_blank" },
                      "Mr. Right"
                    ),
                    "."
                  )
                )
              ),
              view.el(
                ["teamMemberSec", 3],
                null,
                view.el(["img", 5], { className: "portrait", src: "/images/daniel-headshot.png" }),
                view.el(
                  ["teamMemberInfo", 3],
                  null,
                  view.el(
                    ["teamMemberName", 3],
                    null,
                    "Daniel Crosser",
                    view.el(
                      ["a", 3],
                      { className: "teamMemberEmailLink", href: "mailto:daniel@positiverelating.tv" },
                      view.el(["img", 6], { className: "teamMemberEmail", src: "/images/email.png" })
                    )
                  ),
                  view.el(
                    ["teamMemberTitle", 3],
                    null,
                    "Head Coach"
                  ),
                  view.el(
                    ["teamMemberBio", 3],
                    null,
                    "Daniel is the author of ",
                    view.el(
                      ["i", 2],
                      null,
                      "Relationship Formula"
                    ),
                    " and has logged over 5,000 hours of experience coaching students in sparking attraction and building authentic, fulfilling relationships. He has helped many couples work through complex relationship situations and is ",
                    view.el(
                      ["Link", 11],
                      { className: "aboutLink", to: "http://integralcenter.org/t3/", target: "_blank" },
                      "T3 Integral Circling"
                    ),
                    " certified. He now oversees the coaching curriculum at Positive Relating."
                  )
                )
              )
            )
          )
        );
      });view.render(function () {
        return view.el(["Footer", 1], null);
      });

      "28439e14";

      $["page"] = function (_, _index) {
        return { flexDirection: context.isMobile.get() ? 'column' : 'row'
        };
      };

      "122f3ef8";
      "7c6e598d";

      $["aboutSec"] = function (_, _index) {
        return { marginRight: context.isMobile.get() ? 0 : 80
        };
      };

      "1484c247";

      $["para"] = function (_, _index) {
        return { color: context.colors.get()["default"] };
      };

      "1babe06c";

      $["aboutLink"] = function (_, _index) {
        return {
          color: context.colors.get().logoPrimary };
      };

      "a4df4d6a";
      "e751e180";

      $["portrait"] = function (_, _index) {
        return {
          width: context.isMobile.get() ? 80 : 120,
          height: context.isMobile.get() ? 80 : 120 };
      };

      "b58c8714";

      $["teamMemberName"] = function (_, _index) {
        return { marginTop: context.isMobile.get() ? 0 : 2 };
      };

      "6a5d2b63";
      "70ad5c44";
      "2d7901e4";

      $["teamMemberBio"] = function (_, _index) {
        return { color: context.colors.get()["default"]
        };
      };
    });
  })
})();
//# sourceMappingURL=aboutPage.js.map
